<template>
  <div class="ml-6 permission-row">
    <div>
      <ngc-checkbox
        :selected.prop="permission.value"
        :title-text="permission.display_name"
        :disabled="viewOnly || permission.view_only"
        :data-cy="dataCy"
        class="mb-3"
        @change="handleChange(permission)"
      />
    </div>
    <template v-if="permission.value && permission.children.length > 0">
      <div
        v-for="(child, index) in permission.children"
        :key="index"
        class="ml-12"
      >
        <ngc-checkbox
          :selected.prop="child.value"
          :title-text="child.display_name"
          :disabled="viewOnly"
          class="mb-3"
          @change="handleChange(child)"
        />
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'SrPermissionRow',
  props: {
    permission: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    dataCy: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
  },
  methods: {
    handleChange (permission) {
      const changedPermissions = []
      permission.value = !permission.value
      changedPermissions.push(permission.key)
      if (permission.children.length > 0) {
        permission.children.forEach(child => {
          if (child.value !== permission.value) {
            child.value = permission.value
            changedPermissions.push(child.key)
          }
        })
      }
      this.$emit('permissionChange', changedPermissions)
    }
  }
}
</script>

<style lang="scss" scoped>

.permission-row {
  margin: 0;
}

ngc-checkbox[disabled] {
  opacity: 0.45;
}

// ngc-checkbox renders as a full-width block by default, but data-cy lives
// directly on it now (no wrapper span like the old sn-checkbox setup). Without
// constraining it to its content, a Cypress .click() (which targets the
// center of the element's bounding box) lands in empty space to the right of
// the checkbox/label instead of on the actual control, so it never toggles.
// width (not display) is constrained here so we don't disturb ngc-checkbox's
// own vertical spacing/layout.
ngc-checkbox {
  width: fit-content;
}

</style>
